import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/guaData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-base font-bold text-background-50">瓜</span>
          <span
            className={`text-lg font-bold tracking-wide transition-colors ${solid ? "text-foreground-950" : "text-background-50"}`}
          >
            吃瓜榜单
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors hover:bg-primary-500/10 ${
                solid ? "text-foreground-700 hover:text-primary-600" : "text-background-100 hover:bg-background-50/10 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors sm:inline-flex ${
              solid ? "bg-primary-500 text-background-50 hover:bg-primary-600" : "bg-background-50 text-foreground-950 hover:bg-white"
            }`}
          >
            订阅瓜讯
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-lg transition-colors lg:hidden ${
              solid ? "text-foreground-950 hover:bg-background-100" : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-500/10 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              订阅瓜讯
            </a>
          </div>
        </div>
      )}
    </header>
  );
}